// extracted by css-extract-rspack-plugin
export default {"circularMarkerIcon":"T9tFVt"};